module.exports = __webpack_public_path__ + "media/application/images/svgs/cancer_card_rev-4b65633f129e3ecd46483b1c007fcfa5.svg";